import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { environment } from '../../../../../../environments/environment.development';
import { ApiResponse } from '../../../../../core/models/api-response.models';
import { ErrorHandlingService } from '../../../../../core/services/error-handling.service';
import {
  ApiResponsePlanPaginatedResult,
  BipPrintData,
} from './print-bip.interface';

@Injectable({
  providedIn: 'root',
})
export class PrintBipService {
  private readonly API_URL = `${environment.apiUrl}/BehaviorReport`;
  constructor(
    private readonly errorHandler: ErrorHandlingService,
    private readonly http: HttpClient
  ) {}

  getPrintBipData(caseId: number) {
    return this.http
      .get<
        ApiResponse<BipPrintData>
      >(`${this.API_URL}/print-bip?caseId=${caseId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  calculateAge(dateOfBirth: string): number {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  getCaseAttachmentsByPlanTypeAndCaseId(caseId: number) {
    return this.http
      .get<ApiResponsePlanPaginatedResult>(
        `${environment.apiUrl}/caseattachment/get-list-by-plantypeid-caseid?caseId=${caseId}`
      )
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
